import { render } from "./k-avatar-edit.vue?vue&type=template&id=4478d840"
import script from "./k-avatar-edit.vue?vue&type=script&lang=js"
export * from "./k-avatar-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__